import { hot } from "react-hot-loader/root";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import BusinessPartnerDetails from "./components";

import { setMenuKey } from "../../actions";

import {
  fetchLookUp,
  fetchCitiesAndPostalCodesByCountry,
  checkDubplicateOf,
  resetDuplicateBPs,
  resetDuplicateBPDeletedFlag,
  createCity,
  resetCityCreatedFlag,
  createBusinessPartner,
  createPostalCode,
  // updatePostalCode,
  resetBPCreatedFlag,
  resetBPUpdatedFlag,
  setSelectedBP,
  updateBusinessPartner,
  updateCity,
  resetPostalCodeCreatedFlag,
  updatePostalCode,
  resetCityUpdatedFlag,
  resetPostalCodeUpdatedFlag,
  retainUpdatedBusinessParter,
  resetSelectedBP,
  deleteBusinessPartner,
  resetDeleteBPSucceeded,
  flushCountryDependentLookupData,
  fetchBicSwifts,
  resetBicSwifts,
  fetchBankBranch,
  resetBankBranch
} from "./store/actions";

const mapStateToProps = ({ businessPartner, app }) => ({
  bpTypes: businessPartner.bpTypes,
  countries: businessPartner.countries,
  currencyRefs: businessPartner.currencyRefs,
  targetSystems: businessPartner.targetSystems,
  banks: businessPartner.banks,
  cities: businessPartner.cities,
  postalCodes: businessPartner.postalCodes,
  duplicateBPs: businessPartner.duplicateBPs,
  languages: businessPartner.languages,
  cityCreated: businessPartner.cityCreated,
  poBoxCityCreated: businessPartner.poBoxCityCreated,
  cityUpdated: businessPartner.cityUpdated,
  poBoxCityUpdated: businessPartner.poBoxCityUpdated,
  bpCreated: businessPartner.bpCreated,
  bpUpdated: businessPartner.bpUpdated,
  bpRejected: businessPartner.bpRejected,
  selectedBP: businessPartner.selectedBP,
  stateProvinces: businessPartner.stateProvinces,
  postalCodeCreated: businessPartner.postalCodeCreated,
  postalCodeUpdated: businessPartner.postalCodeUpdated,
  statuses: businessPartner.statuses,
  userInfo: app.userInfo,
  deleteBPSucceeded: businessPartner.deleteBPSucceeded,
  bpActivated: businessPartner.bpActivated,
  duplicateBPPagination: businessPartner.duplicateBPPagination,
  bpActions: businessPartner.bpActions,
  pseudoRoleMap: businessPartner.pseudoRoleMap,
  bicSwifts: businessPartner.bicSwifts,
  bankBranch: businessPartner.bankBranch,
  poBoxPostalCodeCreated: businessPartner.poBoxPostalCodeCreated,
  poBoxPostalCodeUpdated: businessPartner.poBoxPostalCodeUpdated,

});

const mapDispatchToProps = {
  setMenuKey,
  fetchLookUp,
  fetchCitiesAndPostalCodesByCountry,
  checkDubplicateOf,
  resetDuplicateBPs,
  resetDuplicateBPDeletedFlag,
  createCity,
  resetCityCreatedFlag,
  createBusinessPartner,
  createPostalCode,
  resetBPCreatedFlag,
  resetBPUpdatedFlag,
  setSelectedBP,
  updateBusinessPartner,
  updateCity,
  resetPostalCodeCreatedFlag,
  updatePostalCode,
  resetCityUpdatedFlag,
  resetPostalCodeUpdatedFlag,
  retainUpdatedBusinessParter,
  resetSelectedBP,
  deleteBusinessPartner,
  resetDeleteBPSucceeded,
  flushCountryDependentLookupData,
  fetchBicSwifts,
  resetBicSwifts,
  fetchBankBranch,
  resetBankBranch
};

const BusinessPartner = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(hot(BusinessPartnerDetails))
);

export default BusinessPartner;
